import MainRoute from './MainRoute';

export default MainRoute;
